module.exports = __webpack_public_path__ + "img/monochrome-logo.93dbed19.png";